/**
 * Pure helper that lets the product registry (fields-other.js) extend FIELDS
 * sections that are defined in the shared lib/fields.js, without those
 * definitions living in the shared file.
 *
 * An extension is either
 *   { entity: 'product', section: { name, key, fields: [...] } }   → appends a new section
 *   { entity: 'customer', sectionKey: 'menuSettings', fields: [...] } → appends fields to that section
 *
 * The base object is never mutated; every touched entity and section is copied.
 */
export function applyFieldExtensions(base, extensions = []) {
    if (!Array.isArray(extensions) || extensions.length === 0) {
        return base;
    }
    const result = { ...base };
    extensions.forEach(extension => {
        if (!extension || !extension.entity) {
            return;
        }
        const sections = Array.isArray(result[extension.entity]) ? result[extension.entity] : [];
        if (extension.section) {
            result[extension.entity] = [...sections, extension.section];
            return;
        }
        if (extension.sectionKey && Array.isArray(extension.fields)) {
            result[extension.entity] = sections.map(section => (
                (section.key === extension.sectionKey || section.name === extension.sectionKey)
                    ? { ...section, fields: [...(section.fields || []), ...extension.fields] }
                    : section
            ));
        }
    });
    return result;
}

export default applyFieldExtensions;
